import React from 'react';
import PropTypes from 'prop-types';
import RichText from 'components/RichText';
import { withContent } from 'components/Content';
import styles from './brandStory.scss';

const CONTENT_KEYS = {
  caption: 'Map Caption',
  map: 'Coverage Map',
};

const BrandStory = ({ content }) => {
  const { caption, map } = content;

  if (!caption || !map) return null;

  const { richText } = caption.fields;
  const { file, description } = map.fields;

  return (
    <section className={styles.brandStory}>
      <figure className={styles.wrapper}>
        <figcaption className={styles.caption}>
          <RichText richText={richText} styles={styles} />
        </figcaption>
        <img
          className={styles.map}
          src={`${file.url}?fm=webp`}
          alt={description}
        />
      </figure>
    </section>
  );
};

BrandStory.propTypes = {
  content: PropTypes.object.isRequired,
};

export default withContent(CONTENT_KEYS)(BrandStory);
